// AUTO-GENERATED CODE, DO NOT EDIT!
/* eslint-disable */

import * as Types from '../../../../types';

import gql from 'graphql-tag';
import * as Urql from 'urql';
export type Omit<T, K extends keyof T> = Pick<T, Exclude<keyof T, K>>;
export type DocumentsProposalFragment = { __typename?: 'Proposal', documents?: Array<{ __typename?: 'ProposalDocument', filename: string, URL: string, s3Key: string }> | null };

export type DocumentsGetProposalDocumentUrlMutationVariables = Types.Exact<{
  filename: Types.Scalars['String'];
  eventID: Types.Scalars['Int'];
}>;


export type DocumentsGetProposalDocumentUrlMutation = { __typename?: 'Mutation', getProposalDocumentUrl: { __typename?: 'ProposalSignedUrlData', URL: string, s3Key: string } };

export const DocumentsProposalFragmentDoc = gql`
    fragment DocumentsProposal on Proposal {
  documents {
    filename
    URL
    s3Key
  }
}
    `;
export const DocumentsGetProposalDocumentUrlDocument = gql`
    mutation DocumentsGetProposalDocumentUrl($filename: String!, $eventID: Int!) {
  getProposalDocumentUrl(filename: $filename, eventID: $eventID) {
    URL
    s3Key
  }
}
    `;

export function useDocumentsGetProposalDocumentUrlMutation() {
  return Urql.useMutation<DocumentsGetProposalDocumentUrlMutation, DocumentsGetProposalDocumentUrlMutationVariables>(DocumentsGetProposalDocumentUrlDocument);
};